// NPM MODULES
import React, { useEffect, useState, useCallback } from 'react';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';

// COMPONENTS
import Loader from '../../common/Loader';

// FORMATTED MESSAGES
import FormattedMessages from '../../../messages/reports/ReplyReportsFormattedMessages';

// NETWORKING
import useReplyReportRequest from '../../../requests/ReplyReportRequest';

const ReplyReportSingle = ({ selected, errorHandler }) => {
  const navigate = useNavigate();
  const { getSingleReplyData } = useReplyReportRequest();
  const [replyMessage, setReplyMessage] = useState(null);
  const [originalMessage, setOriginalMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(async () => {
    try {
      const { smsReplyMessage, originalMessage } = await getSingleReplyData(
        selected.reply_id,
        errorHandler
      );
      console.log(selected.reply_id, smsReplyMessage, originalMessage);
      setReplyMessage(smsReplyMessage);
      setOriginalMessage(originalMessage);
    } catch (error) {
      console.error('Error loading reply data:', error);
      errorHandler?.(error);
    } finally {
      setLoading(false);
    }
  }, [errorHandler]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (loading) {
    return <Loader />;
  }
  const emailSent = replyMessage?.sms_sent
    ? DateTime.fromISO(replyMessage.sms_sent)
        .setZone(localStorage.getItem('timeShort'), {
          keepLocalTime: false,
        })
        .toFormat('dd-LLL-yyyy h:mm a')
    : 'Pending Delivery';
  const sentDate = originalMessage
    ? DateTime.fromISO(originalMessage.sms_sent)
        .setZone(localStorage.getItem('timeShort'), {
          keepLocalTime: false,
        })
        .toFormat('dd-LLL-yyyy h:mm a')
    : null;
  const displayOriginalMessage =
    originalMessage && originalMessage.sms_type !== 'XXX';
  return (
    <Box>
      {replyMessage ? (
        <Stack spacing={4}>
          <Box>
            <Typography variant="h2" gutterBottom>
              Reply Details
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography fontWeight={700}>
                  {FormattedMessages.dateText}
                </Typography>
                <Typography>{emailSent}</Typography>
              </Box>
              <Box>
                <Typography fontWeight={700}>
                  {FormattedMessages.fromText}
                </Typography>
                <Typography>{replyMessage.originator}</Typography>
              </Box>
              <Box>
                <Typography fontWeight={700}>Reply Type</Typography>
                <Typography>{selected.reply_type}</Typography>
              </Box>
              <Box>
                <Typography fontWeight={700}>Delivery Status</Typography>
                <Typography>{replyMessage.sent_status}</Typography>
              </Box>
              <Box>
                <Typography fontWeight={700}>Encoding</Typography>
                <Typography>{replyMessage.smsc_params}</Typography>
              </Box>

              <Box>
                <Typography fontWeight={700}>Incoming Device</Typography>
                <Typography>{replyMessage.device_name}</Typography>
              </Box>
            </Stack>
          </Box>

          <Divider />

          <Box>
            <Typography variant="h2" gutterBottom>
              Original Message Details
            </Typography>
            {displayOriginalMessage ? (
              <Stack spacing={2}>
                {originalMessage.sms_type === 'XXX' && (
                  <Box>
                    <Typography gutterBottom>
                      This is an automatically generated message for an SMS
                      reply without an original message.
                    </Typography>
                    <Typography fontWeight={700}>Send Type</Typography>
                    <Typography>{originalMessage.sms_type}</Typography>
                  </Box>
                )}
                <Box>
                  <Typography fontWeight={700}>Sent Date</Typography>
                  <Typography>{sentDate}</Typography>
                </Box>
                <Box>
                  <Typography fontWeight={700}>User</Typography>
                  <Typography>{originalMessage.user_email}</Typography>
                </Box>
                <Box>
                  <Typography fontWeight={700}>Sent Number</Typography>
                  <Typography>{replyMessage.dest_tn}</Typography>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={originalMessage.sms_type === 'XXX'}
                    onClick={() =>
                      navigate('/reports/allsends', {
                        state: {
                          originalMessage,
                          redirectFromReply: true,
                        },
                      })
                    }
                  >
                    Go To Message Report
                  </Button>
                </Box>
              </Stack>
            ) : (
              <Typography>No original message found.</Typography>
            )}
          </Box>
        </Stack>
      ) : (
        <Typography>No Data</Typography>
      )}
    </Box>
  );
};
export default ReplyReportSingle;
